import { useTenantMemberships } from "@/contexts/TenantContext";

export function useCurrentUserRoles() {
  const { workspaceState } = useTenantMemberships();
  return workspaceState.lazoMembership?.roles ?? [];
}
